var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house-fill (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5 13.125V23.625C24.5 23.857 24.4078 24.0796 24.2437 24.2437C24.0796 24.4078 23.8571 24.5 23.625 24.5H17.5C17.2679 24.5 17.0454 24.4078 16.8813 24.2437C16.7172 24.0796 16.625 23.857 16.625 23.625V17.9375C16.625 17.8215 16.5789 17.7102 16.4969 17.6281C16.4148 17.5461 16.3035 17.5 16.1875 17.5H11.8125C11.6965 17.5 11.5852 17.5461 11.5031 17.6281C11.4211 17.7102 11.375 17.8215 11.375 17.9375V23.625C11.375 23.857 11.2828 24.0796 11.1187 24.2437C10.9546 24.4078 10.7321 24.5 10.5 24.5H4.375C4.14294 24.5 3.92038 24.4078 3.75628 24.2437C3.59219 24.0796 3.5 23.857 3.5 23.625V13.125C3.50022 12.6609 3.68473 12.216 4.01297 11.888L12.763 3.13795C13.0911 2.81001 13.5361 2.62579 14 2.62579C14.4639 2.62579 14.9089 2.81001 15.237 3.13795L23.987 11.888C24.3153 12.216 24.4998 12.6609 24.5 13.125Z",
    fill: "#2A2E37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseFill);
export default __webpack_public_path__ + "static/media/house-fill.27519280dcad3b37092b45ef7d8b897f.svg";
export { ForwardRef as ReactComponent };